import { render, staticRenderFns } from "./warehousePackingList.vue?vue&type=template&id=5dd8995e&scoped=true&"
import script from "./warehousePackingList.vue?vue&type=script&lang=js&"
export * from "./warehousePackingList.vue?vue&type=script&lang=js&"
import style0 from "./warehousePackingList.vue?vue&type=style&index=0&id=5dd8995e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd8995e",
  null
  
)

export default component.exports